"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _LeadFormModal = _interopRequireDefault(require("./LeadFormModal"));
var _CTAButton = _interopRequireDefault(require("../CTAButton"));
var _CalendlyModal = _interopRequireDefault(require("./CalendlyModal"));
var _FinproProfileUtility = require("./FinproProfileUtility");
var _constants = require("../../utils/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var AgentSearchList = _ref => {
  var {
    agents,
    currentPage,
    formData,
    setHoverId,
    agencyKey
  } = _ref;
  var formDataAvailable = formData && formData.fields;
  // Lead Form Modal event
  var [showLeadForm, setLeadForm] = (0, _react.useState)(false);
  var [leadFormData, setLeadFormData] = (0, _react.useState)(null);
  var handleLeadFormModalShow = props => {
    setLeadForm(true);
    setLeadFormData(props);
  };
  var handleLeadFormModalClose = () => {
    setLeadForm(false);
    setLeadFormData(null);
  };

  // Calendly Modal event
  var [showCalendlyModal, setShowCalendlyModal] = (0, _react.useState)(false);
  var [calendlyLink, setCalendlyLink] = (0, _react.useState)('');
  var handleCalendlyModalShow = calendlyLink => {
    if (calendlyLink) {
      setShowCalendlyModal(true);
      setCalendlyLink(calendlyLink);
    }
  };
  var handleCalendlyModalClose = () => {
    setShowCalendlyModal(false);
    setCalendlyLink('');
  };
  var GetLeadFormLink = agent => {
    if (agent.agency) {
      var label = "Connect with ".concat(agent.firstname);
      var formProps = {
        coreAgencyNumber: agent.agency.coreagencynumber,
        subAgencyNumber: agent.agency.subagencynumber,
        agentId: agent.agentid,
        agencyName: agent.agency.agencyname,
        modalTitle: label
      };
      return /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
        buttonType: 'inline',
        label: label,
        dataId: (0, _FinproProfileUtility.GetCTADataId)(_constants.LEADS_CTA_LABEL, agent.agenturl),
        icon: 'icon-ask',
        iconDirection: 'left',
        onClick: () => handleLeadFormModalShow(formProps)
      });
    } else return null;
  };
  var GetCalendly = props => {
    if (props.calendlyLink) {
      return /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
        buttonType: 'secondary',
        label: 'Schedule an Appointment',
        dataId: (0, _FinproProfileUtility.GetCTADataId)(_constants.CALENDLY_CTA_LABEL, props.agentUrl),
        onClick: () => handleCalendlyModalShow(props.calendlyLink),
        icon: 'icon-external-link',
        iconDirection: 'right'
      });
    } else return null;
  };
  var paginatedAgents = agents.slice((currentPage - 1) * 10, currentPage * 10);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("ul", {
    className: "agent-search-list"
  }, paginatedAgents.map((agent, index) => {
    var _agent$languages, _agent$specialties;
    var uniqueId = agent.agency.coreagencynumber;
    if (agent.agency.subagencynumber) uniqueId += '-' + agent.agency.subagencynumber;
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index + agent.fullname,
      onMouseOver: () => {
        setHoverId(agencyKey[uniqueId]);
      }
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
      className: "agent-search-details"
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      sm: 12,
      md: 8,
      className: "agent-info"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-media-object"
    }, /*#__PURE__*/_react.default.createElement("picture", {
      className: "agent-picture mm-img-circle--xl"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: agent.profileimage,
      alt: "MassMutual financial professional."
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "agent-info"
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "agent-name"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "btn btn-inline",
      href: agent.agenturl
    }, agent.fullname)), /*#__PURE__*/_react.default.createElement("h4", {
      className: "agent-agency"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "btn btn-inline",
      href: agent.agency.agencyurl
    }, agent.agency.agencyname)), /*#__PURE__*/_react.default.createElement("p", {
      className: "agent-address"
    }, "".concat(agent.agency.location.addressline, " ").concat(agent.agency.location.addresslinesextra)), /*#__PURE__*/_react.default.createElement("p", {
      className: "agent-city-state"
    }, "".concat(agent.agency.location.city, ", ").concat(agent.agency.location.state, " ").concat(agent.agency.location.zip)), /*#__PURE__*/_react.default.createElement("a", {
      className: "agent-phone btn btn-inline",
      href: "tel:".concat(agent.workphone)
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-call"
    }), " ".concat(agent.workphone)), formDataAvailable && agent.showlead && /*#__PURE__*/_react.default.createElement(GetLeadFormLink, agent), /*#__PURE__*/_react.default.createElement(GetCalendly, {
      calendlyLink: agent.calendly,
      agentUrl: agent.agenturl
    })))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      sm: 12,
      md: 4
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "agent-languages"
    }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "Languages: "), agent === null || agent === void 0 || (_agent$languages = agent.languages) === null || _agent$languages === void 0 ? void 0 : _agent$languages.join(', '))), /*#__PURE__*/_react.default.createElement("div", {
      className: "agent-specialities"
    }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "Specialties: "), agent === null || agent === void 0 || (_agent$specialties = agent.specialties) === null || _agent$specialties === void 0 ? void 0 : _agent$specialties.join(', ')))))));
  })), formDataAvailable && /*#__PURE__*/_react.default.createElement(_LeadFormModal.default, {
    formData: formData,
    show: showLeadForm,
    data: leadFormData,
    onModelClose: handleLeadFormModalClose
  }), /*#__PURE__*/_react.default.createElement(_CalendlyModal.default, {
    show: showCalendlyModal,
    navigateLink: calendlyLink,
    onModelClose: handleCalendlyModalClose
  }));
};
var _default = exports.default = AgentSearchList;